import * as types from "../types/martHealthDashboard.types";

const initialState = {
  orderNotPartialData: [],
  martHealthDashboardListData: [],
};

const MartHealthDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ORDER_NOT_PARTIAL_DATA:
      return { ...state, orderNotPartialData: action.payload };
    case types.SET_MART_HEALTH_DASHBOARD_LIST_DATA:
      return { ...state, martHealthDashboardListData: action.payload };
    case types.RESET_MART_HEALTH_DASHBOARD_REDUCER:
      return { 
        ...state, 
        ...initialState,
      };
    default:
      return state;
  }
};
export default MartHealthDashboardReducer;
